import { combineReducers } from 'redux';

import { LayoutStoreState, layoutReducer } from './layoutSlice';

export interface StoreState {
  layout: LayoutStoreState;
}

export const myWorkspaceReducer = combineReducers<StoreState>({
  layout: layoutReducer,
});
